import React, { useState, useEffect } from "react";
import { withUser } from "../Contexts/user";

const CountdownTimer = ({ user }) => {
    //es-lint-disable-next-line
    const [countdownDate, setCountdownDate] = useState(
        new Date("12/31/2026").getTime()
    );
    const [state, setState] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const setNewTime = () => {
            if (countdownDate) {
                const currentTime = new Date().getTime();

                const distanceToDate = countdownDate - currentTime;

                let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
                let hours = Math.floor(
                    (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                let minutes = Math.floor(
                    (distanceToDate % (1000 * 60 * 60)) / (1000 * 60)
                );
                let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

                const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

                days = `${days}`;
                if (numbersToAddZeroTo.includes(hours)) {
                    hours = `0${hours}`;
                } else if (numbersToAddZeroTo.includes(minutes)) {
                    minutes = `0${minutes}`;
                } else if (numbersToAddZeroTo.includes(seconds)) {
                    seconds = `0${seconds}`;
                }

                setState({ days: days, hours: hours, minutes, seconds });
            }
        };

        const timer = setInterval(() => setNewTime(), 1000);

        return () => clearInterval(timer);
    }, [countdownDate]);

    const digitClass =
        "time text-lg sm:text-2xl lg:text-4xl font-extrabold leading-none";
    const labelClass = "time-text text-xs sm:text-xs lg:text-sm font-semibold";

    return (
        <div className="layout-countdown-timer countdown-wrapper flex flex-col lg:flex-row items-center w-full max-w-full lg:ml-0">
            {/* Mobile: digits and colons share one grid row so ":" aligns with numbers */}
            <div className="countdown-mobile-grid lg:hidden w-full px-1">
                <div className="countdown-mobile-cell">
                    <span className={digitClass}>{state.days || "0"}</span>
                </div>
                <div className="countdown-mobile-cell countdown-mobile-sep-cell">
                    <span className={`${digitClass} countdown-sep`}>:</span>
                </div>
                <div className="countdown-mobile-cell">
                    <span className={digitClass}>{state.hours || "00"}</span>
                </div>
                <div className="countdown-mobile-cell countdown-mobile-sep-cell">
                    <span className={`${digitClass} countdown-sep`}>:</span>
                </div>
                <div className="countdown-mobile-cell">
                    <span className={digitClass}>{state.minutes || "00"}</span>
                </div>
                <div className="countdown-mobile-cell countdown-mobile-sep-cell">
                    <span className={`${digitClass} countdown-sep`}>:</span>
                </div>
                <div className="countdown-mobile-cell">
                    <span className={digitClass}>{state.seconds || "00"}</span>
                </div>

                <small className={`${labelClass} block text-center`}>Days</small>
                <span
                    className={`${labelClass} invisible select-none`}
                    aria-hidden="true"
                >
                    —
                </span>
                <small className={`${labelClass} block text-center`}>Hours</small>
                <span
                    className={`${labelClass} invisible select-none`}
                    aria-hidden="true"
                >
                    —
                </span>
                <small className={`${labelClass} block text-center`}>Minutes</small>
                <span
                    className={`${labelClass} invisible select-none`}
                    aria-hidden="true"
                >
                    —
                </span>
                <small className={`${labelClass} block text-center`}>Seconds</small>
            </div>

            {/* Desktop: equal flex columns so the timer is centered in the row; logout stays right */}
            <div className="hidden lg:flex lg:flex-1 min-w-0" aria-hidden="true" />

            {/* Desktop (lg+): original column layout */}
            <div className="hidden lg:flex items-center justify-center shrink-0 px-1 lg:px-0">
                <div className="time-section flex flex-col items-center mx-1">
                    <div className={digitClass}>{state.days || "0"}</div>
                    <small className={labelClass}>Days</small>
                </div>
                <div className="time-section flex flex-col items-center mx-1">
                    <div className={digitClass}>:</div>
                </div>
                <div className="time-section flex flex-col items-center mx-1">
                    <div className={digitClass}>{state.hours || "00"}</div>
                    <small className={labelClass}>Hours</small>
                </div>
                <div className="time-section flex flex-col items-center mx-1">
                    <div className={digitClass}>:</div>
                </div>
                <div className="time-section flex flex-col items-center mx-1">
                    <div className={digitClass}>{state.minutes || "00"}</div>
                    <small className={labelClass}>Minutes</small>
                </div>
                <div className="time-section flex flex-col items-center mx-1">
                    <div className={digitClass}>:</div>
                </div>
                <div className="time-section flex flex-col items-center mx-1">
                    <div className={digitClass}>{state.seconds || "00"}</div>
                    <small className={labelClass}>Seconds</small>
                </div>
            </div>
            <div className="hidden lg:flex flex-1 min-w-0 justify-end items-center">
                <div
                    onClick={user && user.auth ? user.auth.logout : null}
                    className="cursor-pointer flex items-center text-white font-bold py-1 px-4 rounded-full justify-center"
                    style={{ backgroundColor: "#d1a866" }}
                >
                    LOGOUT
                </div>
            </div>
        </div>
    );
};

export default withUser(CountdownTimer);
